import React, { Component } from 'react';
import lang, { selectedLocalization } from '../services/lang';
import { Link } from 'react-router';
import Icon from '../components/Icon';
import './videos.css';
import '../index.css';

import FetchPlease from 'fetch-please';
import { API_URI, MEDIA_URI } from '../services/config';
const api = new FetchPlease(`${API_URI}/`);
import { beep } from '../services/audio';
import { trackView } from '../services/analytics';

export default class Videos extends Component {
  constructor() {
    super();
    this.state = {
      videos: [],
    };
    
    api.get('videos').then(res => {
      this.setState({videos:res});
    });

    trackView("Patient Stories");
  }
  
  componentWillMount() {
    beep();
  }
  
  componentWillUnmount() {
    api.abort();
  }
  
  renderVideo = video => {
    const photo = `${MEDIA_URI}/${video.photo.path}${video.photo.filename}`;
    const title = video['title_'+selectedLocalization] || video.title;
    const subtitle = video['subtitle_'+selectedLocalization] || video.subtitle;

    const Wrapper = !!window.cordova 
      ? ({children}) => <div onClick={() => window.YoutubeVideoPlayer.openVideo(video._id)} className="videos-video">{children}</div>
      : ({children}) => <Link to={`/video/${video._id}`} className="videos-video">{children}</Link>;

    return (
      <Wrapper key={video._id}>
        <div 
          className="videos-video-photo"
          style={{
            backgroundImage: `url(${photo})`,
          }}
        />
        <div className="videos-video-info">
          <div className='videos-video-title'>{title}</div>
          <div className='videos-video-subtitle'>{subtitle}</div>
        </div>
      </Wrapper>
    );
  }
  
  render() {
    const { videos } = this.state;
    return (
      <div className="videos">
        <div className="videos-content">
          <h1 className="videos-title">{lang('patient-stories-title')}</h1>
          <h3 className="videos-subtitle">{lang('patient-stories-subtitle')}</h3>
          <div className="videos-videos-container">
            <div className="videos-videos">
              {videos.map(this.renderVideo)}
            </div>
          </div>
        </div>
        <div className="videos-menu-row">
          <div className="videos-menu">
            <h5 className="videos-menu-subtitle">{lang('patient-stories-title')}</h5>
            <Link to="/menu" className="videos-menu-main">
              {lang('main-menu')} <Icon name="menuWhite" className="videos-menu-main-icon"/>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Videos.js